export default __webpack_public_path__ + "static/media/samuraiSociety.79d20a88.png";